import { render, staticRenderFns } from "./ReportQuote.vue?vue&type=template&id=881ce922&scoped=true"
import script from "./ReportQuote.vue?vue&type=script&lang=js"
export * from "./ReportQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ce922",
  null
  
)

export default component.exports